/**
 * @desc: 文件描述
 * @author: zengtiansheng
 * @update: 2018/3/17
 */
export const validateMoney = {
  validator: function (rule, value, callback) {
    if (!value) {
      callback(new Error('请填写金额'))
    } else {
      if (/^\d+(\.\d{1,2})?$/.test(value)) {
        callback()
      } else {
        callback(new Error('金额必须为整数或小数，小数点后不超过2位'))
      }
    }
  },
  trigger: 'change'
}
export const validateNunber = (option) => {
  return {
    validator: function (rule, value, callback) {
      if (/^[0-9]*$/.test(value)) {
        if (option.len) {
          if (value.length === option.len) {
            callback()
          } else {
            callback(new Error(option.message))
          }
        } else {
          callback()
        }
      } else {
        callback(new Error(option.message))
      }
    },
    trigger: 'blur'
  }
}
export const validateMobile = (option) => {
  return {
    validator: function (rule, value, callback) {
      if (/^[0-9]*$/.test(value)) {
        if (value.length === 11) {
          callback()
        } else {
          callback(new Error(option.message))
        }
      } else {
        callback(new Error(option.message))
      }
    },
    trigger: 'blur'
  }
}



// WEBPACK FOOTER //
// ./src/libs/formRules.js